/*
 * Copyright (c), Onnorokom Web Services Ltd (OWSL) and/or its affiliates. All rights reserved.
 * OWSL PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
*/

import { setCookie, getCookie, deleteCookie } from 'common-js/cooke-util';

const PAGE_CONTEXT = $('meta[name=context-path]').attr('content');
const CSRF = $('meta[name=csrf-token]').attr('content');

// request notification popup
// If user ignore the popup then the popup will be shown again after 30 min
// If user press denied on the popup then popup will be shown again after 10 days
const NOTIFICATION_POPUP_SHOWN_COOKIE_NAME = 'nt_pop_shown';
const NOTIFICATION_POPUP_SHOWN_COOKIE_TTL_DAYS = 0.02; // approx 30 min

const NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME = 'nt_pop_perm_denied';
const NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_TTL_DAYS = 10; // 10 days

const FIREBASE_COOKIE_NAME = 'fbse';
const FIREBASE_COOKIE_TTL_DAYS = 10;

const NOTIFICATION_PERMISSION_COOKIE_NAME = 'nt_perm';
const NOTIFICATION_PERMISSION_COOKIE_TTL_DAYS = 365;

// Notification request content will cycle after each 5 days
const NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_KEY = 'nt_req_con_indx';
const NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_TTL_DAYS = 5;

const SUBSCRIBED_CATEGORY_COOKIE_NAME = 'nt_subscribed';

const NOTIFICATION_CONTENT = [
    {
        titleText: 'প্রিয় গ্রাহক, রকমারি আপনার পছন্দের ক্যাটাগরির নতুন যে কোন পণ্য এবং এক্সক্লুসিভ সব অফার সম্পর্কে সবার আগে জানাতে চায়।',
        allowText: 'আপডেট পেতে চাই',
        deniedText: 'আগ্রহ নেই',
        topic: 'ALL'
    },
    {
        titleText: 'লক্ষ লক্ষ মানুষের সাথে আপনিও আত্ম-উন্নয়নের পথে সহযাত্রী হতে চান?',
        allowText: 'নিজের উন্নয়ন চাই',
        deniedText: 'পরে',
        topic: 'MOTIVATIONAL'
    },
    {
        titleText: 'একদম জিরো লেভেল থেকে ইংলিশে স্পোকেন, রাইটিং, শেখার বিভিন্ন টিপস পেতে আমাদের সাথেই থাকুন।',
        allowText: 'ইংলিশে ভাল করতে চাই',
        deniedText: 'ইচ্ছে নেই',
        topic: 'LANGUAGE_AND_DICTIONARY'
    },
    {
        titleText: 'ইসলামি খুঁটিনাটি বিষয়ের আপডেট পেতে সাবস্ক্রাইব করুন।',
        allowText: 'আপডেট পেতে চাই',
        deniedText: 'এখনই না',
        topic: 'ISLAMIC'
    },
    {
        titleText: 'পড়াশোনার পাশাপাশি দক্ষতা অর্জনের উপায় জানতে এখনই সাবস্ক্রাইব করুন।',
        allowText: 'দক্ষতা অর্জনে ইচ্ছুক',
        deniedText: 'আগ্রহ নেই',
        topic: 'ACADEMIC'
    },
    {
        titleText: 'শিশু-কিশোরদের দারুণ সব বই এবং এক্সক্লুসিভ অফার জানাতে চায়-',
        allowText: 'এখনই অফার পেতে চাই',
        deniedText: 'আগ্রহ নেই',
        topic: 'CHILDREN'
    },
    {
        titleText: 'গল্প, উপন্যাস কিংবা কবিতা নতুন সব বইয়ের আপডেট জানতে সঙ্গে থাকুন।',
        allowText: 'জানতে চাই',
        deniedText: 'পরে',
        topic: 'FICTION'
    }
];

$(() => {
    const TOPIC_NAME = $('#js--category-id').val() !== '' ? $('#js--category-id').val() : $('#js--url-name').val();

    const getNotificationContentIndex = (topic) => NOTIFICATION_CONTENT.findIndex(item => item.topic === topic);

    /**
     * The function sets a cookie with a topic name if it is not already included in the cookie's content
     * index.
     * @param {string} name - The parameter "name" is a string that represents the name of a topic or content index.
     * This function checks if the name already exists in a cookie called
     * "NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_KEY". If it does not exist, it adds the name to the
     * cookie.
     */
    function setTopicWiseIndexCookies(name) {
        const contentIndexCookie = getCookie(NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_KEY) || JSON.stringify([]);

        if (contentIndexCookie !== '0' && !JSON.parse(contentIndexCookie).includes(name)) {
            setCookie(
                NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_KEY,
                JSON.stringify([...JSON.parse(contentIndexCookie), name]),
                NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_TTL_DAYS
            );
        }
    }

    /**
     * The function handles showing a notification popup based on certain conditions.
     * @param {string} name - A string representing the name of the notification popup.
     * @param {object} content - The content parameter is the message or information that will be displayed in the
     * notification popup.
     * @param {string} topic - The topic parameter is not used in the given function. It is not being passed as an
     * argument to any other function or variable.
     */
    function handleShowNotificationPopup(name, content, topic) {
        if (Notification.permission === 'denied') {
            return;
        }

        const popupShownCookie = JSON.parse(getCookie(NOTIFICATION_POPUP_SHOWN_COOKIE_NAME)) || [];
        const popupPermissionDeniedCookie = JSON.parse(getCookie(NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME)) || [];
        const subscribedCookie = getCookie(SUBSCRIBED_CATEGORY_COOKIE_NAME) && JSON.parse(getCookie(SUBSCRIBED_CATEGORY_COOKIE_NAME)) || [];

        if (
            popupShownCookie.includes(name) ||
            popupPermissionDeniedCookie.includes(name) ||
            (subscribedCookie.includes(topic) &&
            Notification.permission !== 'default')
        ) {
            return;
        }

        if (!$('#js--entry-popup').is(':visible')) {
            return;
            setTimeout(showNotificationRequestPopup(content, topic), 1500);
        }
    }

    /**
     * The function shows a notification request popup with customizable content.
     * @param {object} content - The `content` parameter is an object
     * @param {string} topic - The topic parameter is not used in the given function. It is not being passed as an
     * argument to any other function or variable.
     */
    function showNotificationRequestPopup(content, topic) {
        if (topic === 'ALL' && Notification.permission === 'granted') {
            return;
        }

        let notificationRequestModal = $('#js--notification-permission-modal');

        notificationRequestModal.find('#js--notification-permission-modal-title').text(content.titleText);
        notificationRequestModal.find('.js--btn-allow').text(content.allowText);
        notificationRequestModal.find('.js--btn-denied').text(content.deniedText);

        notificationRequestModal.show();
        $('#js--notify-overlay').show();
    }

    /**
     * The function sets a cookie to track if a specific popup has been shown to the user.
     * @param {string} name - The name parameter is a string that represents the name of the topic-wise popup that
     * has been shown to the user. This function is used to set a cookie that keeps track of which
     * topic-wise popups have been shown to the user, so that they are not shown again during the same
     * session.
     */
    function setTopicWisePopupShownCookies(name) {
        const shownPopupCookie = getCookie(NOTIFICATION_POPUP_SHOWN_COOKIE_NAME) || JSON.stringify([]);

        if (!JSON.parse(shownPopupCookie).includes(name) && !$('#js--entry-popup').is(':visible')) {
            setCookie(
                NOTIFICATION_POPUP_SHOWN_COOKIE_NAME,
                JSON.stringify([...JSON.parse(shownPopupCookie), name]),
                NOTIFICATION_POPUP_SHOWN_COOKIE_TTL_DAYS
            );
        }
    }

    /**
     * This function deletes a specific cookie from a list of denied cookies for a notification popup.
     * @param {string} name - The name of the topic for which the permission was denied and the corresponding cookie
     * needs to be deleted.
     */
    function deleteTopicWiseDeniedCookies(name) {
        const permissionDeniedCookie = JSON.parse(getCookie(NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME)) || [];

        const filteredPermissionDeniedCookies = permissionDeniedCookie.filter(element => element !== name) || [];

        setCookie(
            NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME,
            JSON.stringify(filteredPermissionDeniedCookies),
            NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_TTL_DAYS
        );
    }

    /**
     * The function sets a cookie to deny permission for a specific topic.
     * @param {string} name - The name of the topic for which the permission has been denied by the user. This
     * function is used to set a cookie that stores the names of all the topics for which the user has
     * denied permission to receive notifications.
     */
    function setTopicWiseDeniedCookies(name) {
        const permissionDeniedCookie = getCookie(NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME) || JSON.stringify([]);

        if (!JSON.parse(permissionDeniedCookie).includes(name)) {
            setCookie(NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME, JSON.stringify([...JSON.parse(permissionDeniedCookie), name]), NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_TTL_DAYS);
        }
    }

    /**
     * The function initializes a notification popup with a specific topic and sets cookies to track its
     * display.
     * @param {string} cookieIndex - The index of the cookie to be set for tracking the notification popup for a
     * specific topic.
     * @param {string} cookieName - The name of the cookie that will be set to track whether the notification popup
     * has been shown to the user or not.
     * @param {string} topic - The topic parameter is a string that represents the topic for which the notification
     * popup is being initialized. It is used to determine the content of the notification popup that will
     * be displayed to the user.
     */
    const initNotificationPopup = (cookieIndex, cookieName, topic) => {
        setTopicWiseIndexCookies(cookieIndex);
        handleShowNotificationPopup(cookieName, NOTIFICATION_CONTENT[getNotificationContentIndex(topic)], topic);
        setTopicWisePopupShownCookies(cookieName);
    }

    /**
     * The function handles topic notifications based on the topic name and trigger point.
     * @param {string} topicName - a string representing the name of the topic for which the notification is being
     * handled
     * @param {string} triggerPoint - The point at which the user interacts with the notification popup, either by
     * allowing or denying permission to receive notifications for the specified topic.
     * @returns a string representing the topic name based on the input topicName and triggerPoint. The
     * returned string is either 'MOTIVATIONAL', 'LANGUAGE_AND_DICTIONARY', 'ISLAMIC', 'ACADEMIC',
     * 'CHILDREN', 'FICTION', or 'ALL'.
     */
    function handleTopicNotification(topicName, triggerPoint) {
        switch (topicName) {
            case 'motivational':
                if (triggerPoint === 'init') {
                    initNotificationPopup('nt_motivational_index', 'nt_motivational_pop_shown', 'MOTIVATIONAL');
                } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_motivational_perm_denied');
                    return 'MOTIVATIONAL';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_motivational_perm_denied');
                }
                break;
            case '23':
                if (triggerPoint === 'init') {
                    initNotificationPopup('nt_language_index', 'nt_language_pop_shown', 'LANGUAGE_AND_DICTIONARY');
                } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_language_perm_denied');
                    return 'LANGUAGE_AND_DICTIONARY';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_language_perm_denied');
                }
                break;
            case 'islamic':
                 if (triggerPoint === 'init') {
                    initNotificationPopup('nt_islamic_index', 'nt_islamic_pop_shown', 'ISLAMIC');
                 } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_islamic_perm_denied');
                    return 'ISLAMIC';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_islamic_perm_denied');
                }
                break;
            case '412':
                 if (triggerPoint === 'init') {
                    initNotificationPopup('nt_academic_index', 'nt_academic_pop_shown', 'ACADEMIC');
                 } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_academic_perm_denied');
                    return 'ACADEMIC';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_academic_perm_denied');
                }
                break;
            case 'shishu-kishore':
                if (triggerPoint === 'init') {
                    initNotificationPopup('nt_children_index', 'nt_children_pop_shown', 'CHILDREN');
                } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_children_perm_denied');
                    return 'CHILDREN';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_children_perm_denied');
                }
                break;
            case 'uponnas':
                if (triggerPoint === 'init') {
                    initNotificationPopup('nt_fiction_index', 'nt_fiction_pop_shown', 'FICTION');
                } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_fiction_perm_denied');
                    return 'FICTION';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_fiction_perm_denied');
                }
                break;
            default:
                if (triggerPoint === 'init') {
                    initNotificationPopup('nt_all_index', 'nt_all_pop_shown', 'ALL');
                } else if (triggerPoint === 'allow') {
                    deleteTopicWiseDeniedCookies('nt_all_perm_denied');
                    return 'ALL';
                } else if (triggerPoint === 'denied') {
                    setTopicWiseDeniedCookies('nt_all_perm_denied');
                }
                break;
        }
    }

    if (('Notification' in window)) {
        handleTopicNotification(TOPIC_NAME, 'init');
    }

    /**
     * The function saves a Firebase Cloud Messaging token to the server and sets cookies based on the
     * success or failure of the operation.
     * @param {string} fcmToken - The Firebase Cloud Messaging (FCM) token that needs to be saved.

     */
    function saveFcmToken(fcmToken) {
        if (!CSRF) return;

        $.ajax({
            method: 'POST',
            url: '/fcm/tokens?_tk=' + CSRF,
            contentType: 'application/json',
            data: JSON.stringify({token: fcmToken}),
            success: (res) => {
                if (fcmToken) {
                    setCookie(FIREBASE_COOKIE_NAME, fcmToken, FIREBASE_COOKIE_TTL_DAYS);
                    setCookie(NOTIFICATION_PERMISSION_COOKIE_NAME, '', -1);
                } else {
                    setCookie(FIREBASE_COOKIE_NAME, fcmToken, -1);
                    setCookie(NOTIFICATION_PERMISSION_COOKIE_NAME, 'denied', NOTIFICATION_PERMISSION_COOKIE_TTL_DAYS);
                }
            },
            error: (err) => {
                console.log('Error during fcm save operation');
                deleteCookie(FIREBASE_COOKIE_NAME);
            }
        });
    }

    /**
     * This function makes an AJAX call to retrieve subscribed topics and stores them in a cookie and
     * session storage.
     * @returns If the `subscribedApiCalled` key is present in the `sessionStorage`, the function will
     * return nothing. Otherwise, it will make an AJAX GET request to the specified URL and on success, it
     * will set a cookie with the name `SUBSCRIBED_CATEGORY_COOKIE_NAME` and the value of the response data
     * converted to a JSON string, and it will set the `subscribedApiCalled
     */
    function getSubscribedTopics() {
        $.ajax({
            method: 'GET',
            url:  `${PAGE_CONTEXT}/fcm/subscribed-topics`,
            success: (res) => {
                if (isValidContentForSubscription()) {
                    setCookie(SUBSCRIBED_CATEGORY_COOKIE_NAME, JSON.stringify(res));
                    sessionStorage.setItem('subscribedApiCalled', true);
                }
            },
            error: (err) => {
                console.log('Error occured!');
            }
        });
    }

    function isValidContentForSubscription(resource) {
        return typeof resource === 'object';
    }

    function isLoggedIn() {
        return $('meta[name=user-id]').prop('content') !== '' && $('meta[name=user-id]').prop('content') !== undefined;
    }

    if (isLoggedIn() && !sessionStorage.getItem('subscribedApiCalled')) {
        getSubscribedTopics();
    }

    /**
     * The function subscribes a given FCM token to a specified topic using an AJAX POST request.
     * @param {string} topic - The topic to subscribe to for receiving push notifications.
     * @param {string} fcmToken - The FCM token is a unique identifier generated by Firebase Cloud Messaging (FCM)
     * for each device that has installed the app and has been registered to receive push notifications. It
     * is used to send push notifications to the specific device.
     */
    function subscribeToTopic(topic, fcmToken) {
        const subscribedTopicCookie = getCookie(SUBSCRIBED_CATEGORY_COOKIE_NAME) || JSON.stringify([]);

        if (topic === 'ALL') {
            setCookie(SUBSCRIBED_CATEGORY_COOKIE_NAME, JSON.stringify([...JSON.parse(subscribedTopicCookie), topic]));
            return;
        }

        $.ajax({
            method: 'POST',
            url: `${PAGE_CONTEXT}/fcm/subscribe/${topic}?_tk=${CSRF}`,
            contentType: 'application/json',
            data: JSON.stringify({fcmToken: fcmToken}),
            success: (res) => {
                setCookie(SUBSCRIBED_CATEGORY_COOKIE_NAME, JSON.stringify([...JSON.parse(subscribedTopicCookie), topic]));
            },
            error: (err) => {
                console.log('Error during fcm save operation');
            }
        });
    }

    /**
     * The function handles subscribing to a specific topic with a given FCM token or waits for the token
     * to be available before subscribing.
     * @param {string} topic - The topic to subscribe to for push notifications. It can be a specific topic or "ALL"
     * to subscribe to all topics.
     * @param {string} fcmToken - FCM (Firebase Cloud Messaging) token is a unique identifier generated by Firebase
     * for each app instance. It is used to send push notifications to the specific app instance.
     */
    function handleSubscribeTopic(topic, fcmToken) {
        getSubscribedTopics();

        $(document).trigger('NOTIFY::GRANTED');

        if (fcmToken !== null) {
            subscribeToTopic(topic, fcmToken);
        } else {
            $(document).on('fcm', (res) => {
                subscribeToTopic(topic, res.fcmToken);
            });
        }
    }

    /* Handling the click event of a button with class "js--btn-allow" inside an element
    with id "js--notification-permission-modal". It first checks if a meta tag with name "user-id"
    exists, and if not, redirects the user to the login page. Then, it gets a Firebase Cloud Messaging
    (FCM) token from a cookie and creates a topic for notifications. It requests permission from the
    user to show notifications and if the permission is granted, it subscribes the user to the topic
    using the FCM token. If the permission is denied, it */
    $('#js--notification-permission-modal .js--btn-allow').on('click', async () => {
        const topic = handleTopicNotification(TOPIC_NAME, 'allow');

        if ($('meta[name=user-id]').length < 1 && topic !== 'ALL') {
            deleteCookie(NOTIFICATION_POPUP_SHOWN_COOKIE_NAME);
            deleteCookie(NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME);
            location.replace('/login');
            return;
        }

        const fcmToken = getCookie(FIREBASE_COOKIE_NAME);

        await Notification.requestPermission().then((permission) => {
            permission === "denied"
              ? saveFcmToken(null)
              : handleSubscribeTopic(topic, fcmToken);
        });

        $('#js--notification-permission-modal').hide();
        $('#js--notify-overlay').hide();
    });

    $('#js--notification-permission-modal .js--btn-denied').on('click', () => {
        handleTopicNotification(TOPIC_NAME, 'denied');
        $('#js--notification-permission-modal').hide();
        $('#js--notify-overlay').hide();
    });

    $('#js--notification-permission-modal #js--notification-btn-close').on('click', () => {
        $('js--notification-permission-modal').hide();
        $('#js--notify-overlay').hide();
    });

    /* The `navigator.permissions` API to query the user's permission status for
    notifications. It then adds an event listener to listen for changes in the permission status. If the
    permission status changes to "prompt", it deletes certain cookies related to notification popups and
    saves a Firebase Cloud Messaging (FCM) token as null. If the permission status changes to "denied",
    it saves the FCM token as null. */
    navigator.permissions.query({name: 'notifications'}).then(d => {
        d.addEventListener('change', e => {
            if (e.currentTarget.state === 'prompt') {
                // if user reset the permission
                deleteCookie(NOTIFICATION_POPUP_PERMISSION_DENIED_COOKIE_NAME);
                deleteCookie(NOTIFICATION_POPUP_SHOWN_COOKIE_NAME);
                deleteCookie(NOTIFICATION_REQUEST_CONTENT_INDEX_COOKIE_KEY);
                saveFcmToken(null);
            } else if (e.currentTarget.state === 'denied') {
                // if user denied the permission
                saveFcmToken(null);
            }
        });
    });
});
